module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"@:labels.overview"},"fr":{"title":"@:labels.overview"}}')
  delete Component.options._Ctor
}
